import React from "react";
import {Button, Row, Col, Glyphicon, FormControl} from "react-bootstrap";
import AscComponent from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import Favi from "../Elements/Favi/Favi";
import GroupExtensionNumberModal from "./GroupExtensionNumberModal";
import * as GlobalConst from "../../components/AscConstants";
import AscConfirm from '../../components/Modal/AscConfirm';

export default class GroupExtensionNumber extends AscComponent {
    constructor(props) {
        super(props);
        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            // modal item
            show: false,
            modalType: null,

            // select item
            companySelect: [],
            departmentSelect: [],
            floorSelect: [],
            extensionNumberSelect: [],
            groupExtensionDepartmentSelect: [],
            groupExtensionFloorSelect: [],

            // data item
            group_extension_number_id: "",
            company_id: "",
            company_name: "",
            department_id: "",
            department_name: "",
            floor_id: "",
            floor_name: "",
            group_extension_number: "",
            memo: "",
            extension_number: [],
            group_department_id: [],
            group_floor_id: [],
            // button_disabled
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : [],
                "group_department_id" : [],
                "group_floor_id" : [],
                "group_floor_load" : []

            },

            // 追加確認ポップアップ表示のON/OFF
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: ""
        };
        this.floor_load_flag = false;
    }

    componentDidMount = async () => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        }catch(err){
            console.error(err);
            this.isTargetShowAddingConfirmationPopup = false;
        }
    }

    getColumnsData() {
        let itemArr = [];

        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            filterable: false,
            width: this.props.boardWidth.id,
        });
        if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)){
            //oem権限以上の場合、会社名を表示
            itemArr.push({
            Header: this.props.langText.Body.CompanyName,
            accessor: "cm13_departments.cm12_companies.company_name",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.cm12_companies.company_name")} />
            });
        }

        if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)){
            //会社権限以上の場合、拠点名を表示
            itemArr.push({
                Header: this.props.langText.Body.DepartmentName,
                accessor: "cm13_departments.department_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.department_name")} />
            });
        }

        if (
            (this.props.systemParameters.SYSTEM_FLOOR_FLG === "Y" &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) ||
            (this.props.userInfo.floor_flg &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))
        ) {
            //システム権限または拠点管理権限のフロアありの場合、フロア名を表示
            itemArr.push({
                Header: this.props.langText.Body.FloorName,
                accessor: "cm13_departments.floor_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.floor_name")} />
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.GroupExtensionNumberName,
            accessor: "memo",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "memo")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.GroupExtensionNumber,
            accessor: "group_extension_number",
            width: this.props.boardWidth.large,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "group_extension_number")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.ExtensionNumberNum,
            filterable: false,
            width: this.props.boardWidth.large,
            Cell: data => data.row._original.cm51_extension_numbers.length,
        });

        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.smedium,
            Cell: data => {
                let rowData = [];

                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            onClick={this.modalShow("update", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="pencil" />
                        </Button>
                    );
                } else {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            onClick={this.modalShow("read", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="eye-open" />
                        </Button>
                    );
                }

                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={2}
                            bsSize="xsmall"
                            onClick={this.modalShow("delete", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="minus" />
                        </Button>
                    );
                }

                return (rowData);
            }
        });

        return itemArr;
    }

    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : [],
                "group_department_id" : [],
                "group_floor_id" : [],
                "group_floor_load" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
            break;
        }
    }

    modalShow = (modalType, param) => async event => {
        event.preventDefault();

        try {
            this.blockUI();
            this.modalshow_commonInit();
            this.floor_load_flag = false;

            let setData = {
                group_extension_number_id: "",
                company_id: "",
                company_name: "",
                department_id: "",
                department_name: "",
                floor_id: "",
                floor_name: "",
                group_extension_number: "",
                memo: "",
                description: "",
                extension_number: [],
                companySelect: [],
                departmentSelect: [],
                extensionNumberSelect: [],
                groupExtensionDepartmentSelect: [],
                groupExtensionFloorSelect: [],
                group_department_id: [],
                group_floor_id: []
            };

            if (param && param.id) {
                let modalInfo = await this.getModalInfo(param.id);
                param = modalInfo.data ? modalInfo.data[0] : null;
            }

            if (param) {
                setData.group_extension_number_id = param.id
                    ? param.id
                    : setData.inbound_group_info_id;
                setData.company_id = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.id
                    ? param.cm13_departments.cm12_companies.id
                    : setData.company_id;
                setData.floor_flg = param && param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.floor_flg
                    ? param.cm13_departments.cm12_companies.floor_flg === "Y"
                    : null;
                setData.company_name = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.company_name
                    ? param.cm13_departments.cm12_companies.company_name
                    : setData.company_name;
                setData.department_id = param.cm13_departments && param.cm13_departments.id
                    ? param.cm13_departments.id
                    : setData.department_id;
                setData.department_name = param.cm13_departments && param.cm13_departments.department_name
                    ? param.cm13_departments.department_name
                    : setData.department_name;
                setData.department_prefix = param.cm13_departments && param.cm13_departments.department_prefix
                    ? param.cm13_departments.department_prefix
                    : setData.department_prefix;
                setData.floor_id = param.cm13_departments && param.cm13_departments.id ?
                    param.cm13_departments.id :
                    setData.department_id;
                setData.floor_name = param.cm13_departments && param.cm13_departments.floor_name ?
                    param.cm13_departments.floor_name:
                    setData.floor_name;
                setData.group_extension_number = param.group_extension_number
                    ? param.group_extension_number
                    : setData.group_extension_number;
                setData.memo = param.memo
                    ? param.memo
                    : setData.memo;
                setData.description = param.description
                    ? param.description
                    : setData.description;
                setData.extension_number = param.cm51_extension_numbers
                    ? param
                        .cm51_extension_numbers
                        .map(row => {
                            return row.id;
                        })
                    : setData.extension_number;
                setData.group_department_id = param.group_department_id
                    ? param.group_department_id.split(",").map(id => parseInt(id, 10))
                    : [];
                setData.group_floor_id = param.group_floor_id
                    ? param.group_floor_id.split(",").map(id => parseInt(id, 10))
                    : [];
            } else {
                if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                    setData.floor_flg = this.props.userInfo.floor_flg;
                    setData.company_id = this.props.userInfo.company_id;
                    setData.company_name = this.props.userInfo.company_name;
                }

                if (this.props.currentPermission.scope_code === GlobalConst.SCOPE_OBJECT.department.name) {
                    //新規作成時に拠点情報とフロア選択肢をセットする
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                    this.departmentSelectChanged({
                        company_id: setData.company_id,
                        department_prefix: this.props.userInfo.department_prefix,
                        floor_flg: this.props.userInfo.floor_flg
                    });
                    if (setData.floor_flg) {
                        //着信内線_フロア名のセット
                        this.getParentDepartment(
                            setData.company_id,
                            this.props.userInfo.department_prefix
                        )
                            .then((res) => {
                                this.getGroupExtensionFloorSelectData(setData.company_id, [
                                    res.data.department_prefix,
                                ]);
                            })
                            .catch((err) => {
                                alert(this.showErrorObjectMesssage(err));
                            });
                    } else {
                        this.getExtensionNumberSelect({
                            department_id: this.props.userInfo.department_id
                        });
                    }
                }

                if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) {
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                    setData.floor_id = this.props.userInfo.department_id
                    setData.floor_name = this.props.userInfo.floor_name
                    this.getExtensionNumberSelect({
                        department_id: this.props.userInfo.department_id
                    });
                }
            }

            setData.isSetShowAddingConfirmationPopup =
            setData.company_id !== ""
                ? await this.getIsShowAddingConfirmationPopup(setData.company_id)
                : false
            ;

            this.setState(setData);

            this.getCompanySelect();
            this.getDepartmentSelect(setData);

            if (modalType === "update" || modalType === "delete") {
                const selectIds = setData.group_floor_id.length > 0 ? setData.group_floor_id : setData.group_department_id;
                const group_department_id = setData.group_department_id.length === 0 ? this.props.userInfo.parent_department_id : setData.group_department_id;
                this.getDepartmentSelect(
                    setData
                );
                this.getDepartmentPrefixListById(group_department_id)
                    .then(res => {
                        this.getGroupExtensionFloorSelectData(setData.company_id, res);
                    })
                    .catch(err => {
                        alert(this.showErrorObjectMesssage(err));
                    });
                selectIds.push(setData.department_id)
                this.getExtensionNumberSelect({
                    department_id: selectIds,
                });
            }
            this.setState({show: true, modalType});
        } catch (err) {
            this.showErrorObjectMesssage(err);
            this.reactTableRefresh();
        }
    };

    /**
     * 親拠点情報を取得する
     * @param {string} company_id 
     * @param {string} department_prefix 
     */
    getParentDepartment = async(company_id, department_prefix) => {
        try {
            const parentDepartment = await this.ascAxios("post", `Common/getParentDepartment`, {
                company_id: company_id,
                department_prefix: department_prefix.slice(0, 2),
            });
            return parentDepartment;
        } catch (err) {
            throw new Error(err);
        }
    }

    getModalInfo(id) {
        return this.ascAxios('post', `${this.reactContainerPath}/modal`, { id });
    }

    async onSelectChange(event, param) {
        super.onSelectChange(event, param);
        let value = (event && event.value) ? event.value : "";
        let floor_flg = (event && event.floor_flg) ? event.floor_flg === "Y" : "";
        const department_prefix = (event && event.department_prefix) ? event.department_prefix : "";

        switch (param) {
            case "company_id":
                this.setState({
                    department_id: "",
                    floor_id: "",
                    floor_flg,
                    extension_number: [],
                    extensionNumberSelect: [],
                    group_department_id: [],
                    group_floor_id: [],
                    isSetShowAddingConfirmationPopup: await this.getIsShowAddingConfirmationPopup(value)
                });
                this.getDepartmentSelect({company_id: value, floor_flg});
                this.departmentSelectChanged({
                    company_id: this.state.company_id,
                    department_prefix,
                    floor_flg
                });
                break;

            case "department_id":
                this.floor_load_flag = true;
                this.setState({floor_id: ""});
                this.departmentSelectChanged({
                    company_id: this.state.company_id,
                    department_prefix,
                    floor_flg: this.state.floor_flg
                });
                this.state.floor_flg || this.getGroupExtensionDepartmentSelectData(value);
                //内線を一覧取得のため、breakせずに処理を継続させる
            case "floor_id":
                this.setState({extension_number: []});
                const department_id = this.state.floor_flg ? [...this.state.group_floor_id] : [...this.state.group_department_id];
                value && department_id.push(value);
                this.extensionNumberSelectInit(department_id);
                if (
                    this.state.group_floor_id.length > 0 ||
                    this.props.currentPermission.scope_code === GlobalConst.SCOPE_OBJECT.department.name
                ) {
                    this.getDepartmentPrefixListById(this.state.group_department_id)
                        .then((res) => {
                            this.getGroupExtensionFloorSelectData(this.state.company_id, res);
                        })
                        .catch((err) => {
                            alert(this.showErrorObjectMesssage(err));
                        });
                }
                break;

            default:
                break;

        }
    }

    getCompanySelect = () => {
        this
            .ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(res => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({companySelect: res.data});
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data));
            });
    };

    getDepartmentSelect = ({company_id, floor_flg, department_id}) => {
        if(company_id)
        {
            this.common_buttondisabledLengthCheck(`department_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`department_load`,`pop`);
        }
        this
            .ascAxios('post', `Common/departmentSelect`, {
                container: this.reactContainerPath,
                company_id,
                floor_flg})
            .then(res => {
                if(this.state.company_id)
                {
                    this.common_buttondisabledLengthCheck(`department_id`,`push`);
                    this.common_buttondisabledLengthCheck(`department_load`,`pop`);
                }
                else
                {
                    this.common_buttondisabledLengthCheck(`department_id`,`pop`);
                }
                this.setState({departmentSelect: res.data});
                floor_flg || this.getGroupExtensionDepartmentSelectData(department_id, res.data);
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data));
            });
    };

    departmentSelectChanged = ({company_id, department_prefix, floor_flg}, action) => {
        if (floor_flg) {
            if(this.floor_load_flag === true && department_prefix && company_id)
            {
                this.common_buttondisabledLengthCheck(`floor_load`,`push`);
            }
            else
            {
                this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
            }
            this.ascAxios('post', `Common/floorSelect`, {
                container: this.reactContainerPath,
                company_id,
                department_prefix
            })
            .then(res => {
                if(department_prefix)
                {
                    this.common_buttondisabledLengthCheck(`floor_id`,`push`);
                    this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
                    this.floor_load_flag = false;
                }
                else
                {
                    this.common_buttondisabledLengthCheck(`floor_id`,`pop`);
                }
                this.setState({
                    floorSelect: res.data
                })

                if (action === 'changed') {
                    this.setState({
                        floor_id: "",
                    })
                }
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data))
            })
        }
    }

    getExtensionNumberSelect = ({department_id}) => {
        this
            .ascAxios(
                'post',
                `${this.reactContainerPath}/extensionNumberSelect`,
                {department_id}
            )
            .then(res => {
                let extensionNumberSelectData = res.data.cm51_extension_numbers.map(row => {
                    let labeldata = <div>
                                        {row.label}
                                        <Favi
                                            className="pull-right fa-fw fa-icon fa-icon-static"
                                            icon={row.type}
                                        />
                                    </div>;
                    return {
                        search: row.label,
                        label: labeldata,
                        value: row.value
                    }
                });
                this.setState({extensionNumberSelect: extensionNumberSelectData});
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data));
            });
    };

    onClickHandle = modalType => async event => {
        let {
            company_id,
            group_extension_number_id,
            department_id,
            floor_id,
            group_extension_number,
            memo,
            description,
            extension_number,
            group_department_id,
            group_floor_id,
            isSetShowAddingConfirmationPopup,
            confirmMemo
        } = this.state;

        // 追加確認ポップアップの表示条件チェック
        if (
            this.isTargetShowAddingConfirmationPopup &&
            isSetShowAddingConfirmationPopup
        ) {
            // 追加確認ポップアップを表示すべき場合
            if (!this.state.showConfirm) {
                // 初回ボタン押下時：追加確認ポップアップを表示
                this.onClickConfirm(event, true);
                return;
            }
        } else {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.GroupExtensionNumberName,
                this.state.memo,
                modalType
            )}`)) {
                return;
            }
        }

        switch (modalType) {
            case "insert":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/insert`, {
                        company_id: company_id,
                        department_id: floor_id || department_id,
                        group_extension_number,
                        memo,
                        description,
                        extension_number ,
                        group_department_id: group_department_id.join(","),
                        group_floor_id: group_floor_id.join(","),
                        confirmMemo
                    })
                    .then(res => {
                        alert(
                            `${this.props.langText.Message.DataInsertSuccess}\r\n   ${this.props.langText.Body.GroupExtensionNumberName}: ${res.data.memo}\r\n   ${this.props.langText.Body.ExtensionNumberNum}: ${res.data.extension_count}`
                        );
                        this.reactTableRefresh();
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                    });
                break;

            case "update":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/update`, {
                        company_id,
                        group_extension_number_id,
                        department_id: department_id,
                        group_extension_number,
                        memo,
                        description,
                        extension_number,
                        group_department_id: group_department_id.join(","),
                        group_floor_id: group_floor_id.join(","),
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(res => {
                        alert(
                            this.props.langText.Message.DataUpdateSuccess
                        );
                        this.reactTableRefresh();
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                    });
                break;

            case "delete":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/delete`, {
                        company_id,
                        group_extension_number_id,
                        memo,
                        group_extension_number,
                        extension_number,
                        confirmMemo
                    })
                    .then(res => {
                        alert(
                            this.props.langText.Message.DataDeleteSuccess
                        );
                        this.reactTableRefresh();
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                    });
                break;

            default:
                alert(this.getErrorString({code: "modal"}));
        }

        this.setState({
            show: false, 
            showConfirm: false,
            confirmMemo: ""
        });
    };

    validationHandle = param => {
        let nowState = null;

        switch (param) {
            case "company_id":
            case "department_id":
            case "floor_id":
            case "memo":
                nowState = this.state[param]
                    ? null
                    : "error"
                break;

            case "group_extension_number":
                nowState = this.state[param].length === 3
                    ? null
                    : "error"
                break;
            case "insert":
            case "update":
            case "delete":
                let {
                    company_id,
                    department_id,
                    floor_id,
                    floor_flg,
                    group_extension_number,
                    memo,
                } = this.state
                if(!floor_flg)
                {
                    nowState = (
                        company_id
                        && department_id
                        && group_extension_number.length === 3
                        && memo
                    )
                }
                else
                {
                    nowState = (
                        company_id
                        && floor_id
                        && group_extension_number.length === 3
                        && memo
                    )
                }
                break;

            default:
                break;

        }

        return nowState;
    };

    /**
     * マルチセレクトボックスのチェンジイベント
     * @param {*} event 
     * @param {*} param 
     */
    onMultiSelectChange(event, param) {
        if (this.state.group_floor_id) {
            this.common_buttondisabledLengthCheck(`group_floor_load`,`pop`);
        } else {
            this.common_buttondisabledLengthCheck(`group_floor_load`,`push`);
        }
        super.onMultiSelectChange(event, param);
        let value_arr = [];
        const departmentIds = event.map(item => item.value);


        switch (param) {
            case "group_department_id":
                if (this.state.floor_flg) {
                    const departmentIds = [];
                    //フロア有の場合はプレフィックスを格納してフロア一覧の検索条件にする
                    event.forEach(row => {
                        value_arr.push(row.department_prefix);
                        departmentIds.push(row.value);
                    });
                    if (departmentIds.length > 0 ) {
                        this.getGroupExtensionFloorSelectData(this.state.company_id, value_arr);
                        this.common_buttondisabledLengthCheck(`group_department_id`,`push`);
                    } else {
                        if (!this.state.floor_id || !this.state.department_id) {
                            //拠点名（フロア名）が選択されていない場合に初期化する
                            this.setState({
                                group_floor_id: [],
                                extension_number: [],
                                extensionNumberSelect: []
                            });
                        } else {
                            //拠点が削除された場合、所属するフロア、内線番号を再セットする
                            this.setState({
                                group_floor_id: [],
                            });
                            departmentIds.push(this.state.floor_id || this.state.department_id);
                            this.extensionNumberSelectInit(departmentIds);
                        }
                        this.getExtensionNumberSelect({ department_id: [this.state.floor_id]});
                        this.common_buttondisabledLengthCheck(`group_department_id`,`pop`);
                    }
                    this.common_buttondisabledLengthCheck(`group_floor_load`,`pop`);
                } else {
                    departmentIds.push(this.state.floor_id || this.state.department_id);
                    this.extensionNumberSelectInit(departmentIds);
                }
                break;
            case "group_floor_id":
                departmentIds.push(this.state.floor_flg ? this.state.floor_id : this.state.department_id);
                this.extensionNumberSelectInit(departmentIds);
                break;
            default:
        }
    }

    //選択内線番号の初期化
    extensionNumberSelectInit(departmentIds){
        this.getExtensionNumberSelect({ department_id: departmentIds });
        if (departmentIds.length === 0) {
            //拠点（フロア）のリセット時は選択内線番号を初期化
            this.setState({extension_number: []});
        }

        //選択内線番号から検索対象外データを削除
        this.deleteExtensionNumber(departmentIds);
    };

    /**
     * 着信内線_拠点の一覧を取得する
     * @param {*} department_id
     */
    getGroupExtensionDepartmentSelectData (department_id, departmentSelect = this.state.departmentSelect) {
        const groupExtensionDepartmentSelect = departmentSelect.filter(department => {
            if (department_id !== department.value) {
                return department.value;
            }
        });
        this.setState({
            groupExtensionDepartmentSelect,
            group_department_id: this.state.group_department_id.filter(id => {return id !== department_id})});
    }
    /**
     * 着信内線_フロアの一覧を取得する
     * @param {*} company_id 
     * @param {*} department_prefix 
     */
    getGroupExtensionFloorSelectData (company_id, department_prefix) {
        const departmentPrefix = department_prefix.length === 0 ? [this.state.department_prefix] : department_prefix;
        this.common_buttondisabledLengthCheck(`group_department_id`, `push`);
        this.ascAxios("post", `${this.reactContainerPath}/getGroupExtensionFloorSelectData`, {
            company_id,
            department_prefix: departmentPrefix
        })
            .then((res) => {
                const groupExtensionFloorSelect = [];
                let floorIds = [];
                res.data.forEach(row => {
                    if (row.id !== this.state.floor_id) {
                        //選択されているフロアは着信拠点_フロア名には重複して表示しない
                        groupExtensionFloorSelect.push({value: row.id, label: row.floor_name});
                    }
                    if (this.state.group_floor_id.indexOf(row.id) !== -1) {
                        //検索条件にないフロアの選択を解除
                        floorIds.push(row.id);
                    }
                });
                this.setState({
                    groupExtensionFloorSelect,
                    group_floor_id: floorIds.filter(id => {return id !== this.state.floor_id}),
                    department_prefix: departmentPrefix
                });
                const departmentIds = [...floorIds];
                departmentIds.push(this.state.floor_id);
                this.state.floor_flg && this.extensionNumberSelectInit(departmentIds);
                if (groupExtensionFloorSelect.length === 0) {
                    this.common_buttondisabledLengthCheck(`group_department_id`, `pop`);
                }
            })
            .catch((err) => {
                this.common_buttondisabledLengthCheck(`group_department_id`, `pop`);
            });
    }

    /**
     * プレフックスの取得
     * @param {*} department_id
     * @returns {array}
     */
    async getDepartmentPrefixListById (department_id) {
        this.common_buttondisabledLengthCheck(`group_department_id`, `push`);
        const resultPrefixList = await this.ascAxios("post", `${this.reactContainerPath}/getDepartmentPrefixListById`, {
            department_id
        });
        return resultPrefixList.data.map(prefix => prefix.department_prefix);
    }

    /**
     * 着信内線の拠点名（フロア名）が選択条件から削除された場合、選択済みの内線番号を未選択に更新する
     * @param {*} department_id
     * @returns {array}
     */
    async deleteExtensionNumber (departmentIds) {
        if (this.state.extension_number.length === 0) {
            //内線番号の選択件数が0件なら処理を行わない
            return false;
        }
        const result = await this.ascAxios("post", `${this.reactContainerPath}/getExtensionNumberByDepartmentId`, {
            department_id: departmentIds,
            extension_number: this.state.extension_number
        });
        this.setState({extension_number: result.data.map(extension_number => extension_number.id)});
    }

    render() {
        return (
            <div className="GroupExtensionNumber">
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id="groupExtensionNumber-insert"
                                className="table-button"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow('insert')}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                        </Col>
                    }
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = "manual"
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}/>
                    </Col>
                </Row>
                <GroupExtensionNumberModal
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        onClick = {this.onClickHandle}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onSelectChange = {this.onSelectChange}
                        onMultiSelectChange = {this.onMultiSelectChange}
                        onCheckBoxChange = {this.onCheckBoxChange}
                        onKeyDownIntCheck = {this.onKeyDownIntCheck}
                        validationHandle = {this.validationHandle}
                        getScopeGreaterEqual = {this.getScopeGreaterEqual}
                />
                {/* 追加確認ポップアップ */}
                {
                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        key={this.state.modalType} // modalTypeが変更されたときに強制的に再マウント
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onClick={this.onClickHandle}
                        charaLimit={this.props.charaLimit}
                        onTextChange_Limit={this.onTextChange_Limit}
                        confirmKey={this.props.langText.Body.GroupExtensionNumber}
                        confirmKeyItem={this.state.memo}
                        sprintf={this.sprintf}
                        customBtn1Func={this.onClickConfirm}
                    />
                }
            </div>
        );
    }
}
